module.exports = __webpack_public_path__ + "media/images/partners/bt-43e5b174b16543f59f47cc618608515a.svg";